import { Box, Container, Link, Stack, Typography } from '@mui/material';

const Footer = () => (
  <Box component="footer" sx={{ borderTop: '1px solid', borderColor: 'divider', py: 4, bgcolor: '#fff' }}>
    <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
      <Box component="img" src="/securerightslogo.svg" alt="SecureRights" sx={{ height: { xs: 32, md: 40 }, mb: 2 }} />
      <Stack direction="row" spacing={3} justifyContent="center" flexWrap="wrap" sx={{ mb: 2 }}>
        <Link href="/terms-of-service" underline="hover" color="inherit" fontWeight={700} fontSize="0.95rem">
          Terms &amp; Conditions
        </Link>
        <Link href="/privacy-policy" underline="hover" color="inherit" fontWeight={700} fontSize="0.95rem">
          Privacy Policy
        </Link>
        <Link href="mailto:supply@upads.com" underline="hover" color="inherit" fontWeight={700} fontSize="0.95rem">
          Contact: supply@upads.com
        </Link>
      </Stack>
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} SecureRights. All rights reserved.
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1.5, maxWidth: 900, mx: 'auto' }}>
        SecureRights is an online news and information service providing editorial content and directory information
        about mortgages and loans. SecureRights is not a lender or mortgage broker and does not offer loans or mortgages
        directly or indirectly through representatives or agents. SecureRights does not provide an application for
        credit or a mortgage loan. SecureRights is not responsible for the accuracy of information or responsible for
        the accuracy of the rates, APR or loan information posted by brokers, lenders or advertisers. All trademarks and
        logos appearing on this site are the property of their respective owners. Their appearance on this site does not
        indicate or imply an endorsement of our product.
      </Typography>
    </Container>
  </Box>
);

export default Footer;
